export default {
  meta: {
    title: '首页',
    // url: '/fishtogether'
    url: '/fishtogether', // 埋点用，记录所属模块
  }
};

